import React from 'react'
import { motion } from 'framer-motion'
import { Box, Typography, useMediaQuery } from '@material-ui/core'

const ResumeSection = ({
  title,
  icon: Icon,
  children,
  background = '#080808',
  minHeight = '100vh'
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: '-20%' }}
      transition={{ duration: 0.8 }}
      style={{
        minHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        background,
        padding: isMobile ? '2rem 1rem' : '4rem 2rem'
      }}
    >
      <Box style={{
        maxWidth: '1400px',
        width: '100%',
        position: 'relative',
        zIndex: 2
      }}>
        {title && (
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{
              textAlign: 'center',
              marginBottom: isMobile ? '2rem' : '4rem'
            }}
          >
            <Box style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: isMobile ? '0.5rem' : '1rem',
              padding: isMobile ? '0.75rem 1rem' : '1rem 2rem',
              background: 'rgba(0, 0, 0, 0.5)',
              border: '2px solid rgba(0, 255, 255, 0.4)',
              borderRadius: '12px',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 0 30px rgba(0, 255, 255, 0.2)'
            }}>
              {Icon && (
                <Icon style={{
                  fontSize: isMobile ? '1.5rem' : '2rem',
                  color: '#00ffff',
                  filter: 'drop-shadow(0 0 10px rgba(0, 255, 255, 0.5))'
                }}/>
              )}
              <Typography style={{
                fontFamily: '"Orbitron", monospace',
                fontSize: isMobile ? '1.3rem' : '2.5rem',
                fontWeight: 'bold',
                background: 'linear-gradient(90deg, #00ffff 0%, #ff00ff 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                letterSpacing: isMobile ? '0.05em' : '0.1em',
                whiteSpace: isMobile ? 'normal' : 'nowrap',
                textAlign: 'center'
              }}>
                {title}
              </Typography>
            </Box>
          </motion.div>
        )}

        {children}
      </Box>

      <Box style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 1
      }}/>
    </motion.section>
  )
}

export default ResumeSection
